/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Base store URL for each country code.
 *
 * @author Mohamed yasar arabath M
 */

const StoreUrlBase = {
  STORE_URL: {
    TTO: 'https://latam-stg.pearson.com',
    FIN: 'https://eu-stg.pearson.com',
    BMU: 'https://pearson-stg2.pearson.com',
    CO: 'https://latam-stg.pearson.com',
    BHR: 'https://t1-menat-stg.pearson.com',
    SLV: 'https://latam-stg.pearson.com',
    HRV: 'https://eu-stg.pearson.com',
    SGP: 'https://t2-apac-stg.pearson.com',
    MEX: 'https://latam-stg.pearson.com',
    GTM: 'https://latam-stg.pearson.com',
    LUX: 'https://eu-stg.pearson.com',
    LBN: 'https://t2-menat-stg.pearson.com',
    IRL: 'https://pearson-stg2.pearson.com',
    QAT: 'https://t1-menat-stg.pearson.com',
    EST: 'https://eu-stg.pearson.com',
    DEU: 'https://eu-stg.pearson.com',
    UKR: 'https://eu-stg.pearson.com',
    TWN: 'https://t3-apac-stg.pearson.com',
    ASM: 'https://pearson-stg2.pearson.com',
    ZMB: 'https://sa-stg.pearson.com',
    MCO: 'https://pearson-stg2.pearson.com',
    IND: 'https://india-stg.pearson.com',
    PHL: 'https://t3-apac-stg.pearson.com',
    ZAF: 'https://sa-stg.pearson.com',
    AUT: 'https://eu-stg.pearson.com',
    SAU: 'https://t1-menat-stg.pearson.com',
    CHN: 'https://pearson-stg2.pearson.com',
    DOM: 'https://latam-stg.pearson.com',
    MAC: 'https://cn-stg.pearson.com',
    PAN: 'https://latam-stg.pearson.com',
    ISR: 'https://eu-stg.pearson.com',
    UZB: 'https://eu-stg.pearson.com',
    IRN: 'https://pearson-stg2.pearson.com',
    NOR: 'https://eu-stg.pearson.com',
    FRA: 'https://eu-stg.pearson.com',
    CHE: 'https://eu-stg.pearson.com',
    BEL: 'https://eu-stg.pearson.com',
    KAZ: 'https://eu-stg.pearson.com',
    AUS: 'https://pearson-stg2.pearson.com',
    URY: 'https://latam-stg.pearson.com',
    KEN: 'https://sa-stg.pearson.com',
    CYM: 'https://latam-stg.pearson.com',
    BRA: 'https://latam-stg.pearson.com',
    IDN: 'https://t3-apac-stg.pearson.com',
    JAM: 'https://latam-stg.pearson.com',
    PER: 'https://latam-stg.pearson.com',
    EGY: 'https://t2-menat-stg.pearson.com',
    LIE: 'https://pearson-stg2.pearson.com',
    ARM: 'https://t3-apac-stg.pearson.com',
    VNM: 'https://t3-apac-stg.pearson.com',
    LKA: 'https://t3-apac-stg.pearson.com',
    ARE: 'https://t1-menat-stg.pearson.com',
    THA: 'https://t3-apac-stg.pearson.com',
    VEN: 'https://latam-stg.pearson.com',
    SRB: 'https://eu-stg.pearson.com',
    BHS: 'https://latam-stg.pearson.com',
    NIC: 'https://latam-stg.pearson.com',
    MAR: 'https://t2-menat-stg.pearson.com',
    KWT: 'https://t1-menat-stg.pearson.com',
    CAN: 'https://pearson-stg2.pearson.com',
    CHL: 'https://latam-stg.pearson.com',
    ARG: 'https://latam-stg.pearson.com',
    SWE: 'https://eu-stg.pearson.com',
    ECU: 'https://latam-stg.pearson.com',
    PCN: 'https://pearson-stg2.pearson.com',
    OMN: 'https://t1-menat-stg.pearson.com',
    MO: 'https://cn-stg.pearson.com',
    NZL: 'https://pearson-stg2.pearson.com',
    CMR: 'https://sa-stg.pearson.com',
    USA: 'https://pearson-stg2.pearson.com',
    SJM: 'https://pearson-stg2.pearson.com',
    POL: 'https://eu-stg.pearson.com',
    JOR: 'https://t2-menat-stg.pearson.com',
    COL: 'https://latam-stg.pearson.com',
    GEO: 'https://t3-apac-stg.pearson.com',
    ESP: 'https://eu-stg.pearson.com',
    MYS: 'https://t3-apac-stg.pearson.com',
    LVA: 'https://eu-stg.pearson.com',
    CXR: 'https://pearson-stg2.pearson.com',
    BWA: 'https://sa-stg.pearson.com',
    GBR: 'https://pearson-stg2.pearson.com',
    TUR: 'https://t3-menat-stg.pearson.com',
    MKD: 'https://pearson-stg2.pearson.com',
    GUM: 'https://pearson-stg2.pearson.com',
    PRY: 'https://latam-stg.pearson.com',
    CRI: 'https://latam-stg.pearson.com',
    HND: 'https://latam-stg.pearson.com',
    BG: 'https://eu-stg.pearson.com',
    HKG: 'https://cn-stg.pearson.com',
    PSE: 'https://eu-stg.pearson.com',
    NLD: 'https://eu-stg.pearson.com',
    AZE: 'https://t3-apac-stg.pearson.com',
    BLZ: 'https://latam-stg.pearson.com',
    DNK: 'https://eu-stg.pearson.com',
    ISL: 'https://eu-stg.pearson.com',
    JPN: 'https://t2-apac-stg.pearson.com',
    BOL: 'https://latam-stg.pearson.com',
    PRT: 'https://eu-stg.pearson.com',
    ITA: 'https://eu-stg.pearson.com',
    LTU: 'https://eu-stg.pearson.com',
    ALB: 'https://eu-stg.pearson.com',
    BIH: 'https://eu-stg.pearson.com',
    CYP: 'https://eu-stg.pearson.com',
    CZE: 'https://eu-stg.pearson.com',
    GRC: 'https://eu-stg.pearson.com',
    HUN: 'https://eu-stg.pearson.com',
    XKX: 'https://eu-stg.pearson.com',
    KGZ: 'https://eu-stg.pearson.com',
    MLT: 'https://eu-stg.pearson.com',
    MTQ: 'https://eu-stg.pearson.com',
    MDA: 'https://eu-stg.pearson.com',
    MNG: 'https://eu-stg.pearson.com',
    MNE: 'https://eu-stg.pearson.com',
    ROU: 'https://eu-stg.pearson.com',
    SVK: 'https://eu-stg.pearson.com',
    SVN: 'https://eu-stg.pearson.com',
    IRQ: 'https://t1-menat-stg.pearson.com',
    LBY: 'https://t3-menat-stg.pearson.com',
    NGA: 'https://t3-menat-stg.pearson.com',
    PAK: 'https://t3-menat-stg.pearson.com',
    SSD: 'https://t3-menat-stg.pearson.com',
    SDN: 'https://t3-menat-stg.pearson.com',
    SYR: 'https://t3-menat-stg.pearson.com',
    TUN: 'https://t3-menat-stg.pearson.com',
    YEM: 'https://t3-menat-stg.pearson.com',
    DZA: 'https://sa-stg.pearson.com',
    AGO: 'https://sa-stg.pearson.com',
    BEN: 'https://sa-stg.pearson.com',
    BFA: 'https://sa-stg.pearson.com',
    BDI: 'https://sa-stg.pearson.com',
    CPV: 'https://sa-stg.pearson.com',
    CAF: 'https://sa-stg.pearson.com',
    TCD: 'https://sa-stg.pearson.com',
    COM: 'https://sa-stg.pearson.com',
    COG: 'https://sa-stg.pearson.com',
    CIV: 'https://sa-stg.pearson.com',
    DJI: 'https://sa-stg.pearson.com',
    COD: 'https://sa-stg.pearson.com',
    GNQ: 'https://sa-stg.pearson.com',
    ERI: 'https://sa-stg.pearson.com',
    SWZ: 'https://sa-stg.pearson.com',
    ETH: 'https://sa-stg.pearson.com',
    GAB: 'https://sa-stg.pearson.com',
    GMB: 'https://sa-stg.pearson.com',
    GHA: 'https://sa-stg.pearson.com',
    GIN: 'https://sa-stg.pearson.com',
    GNB: 'https://sa-stg.pearson.com',
    LSO: 'https://sa-stg.pearson.com',
    LBR: 'https://sa-stg.pearson.com',
    MDG: 'https://sa-stg.pearson.com',
    MWI: 'https://sa-stg.pearson.com',
    MLI: 'https://sa-stg.pearson.com',
    MRT: 'https://sa-stg.pearson.com',
    MUS: 'https://sa-stg.pearson.com',
    MOZ: 'https://sa-stg.pearson.com',
    NAM: 'https://sa-stg.pearson.com',
    NER: 'https://sa-stg.pearson.com',
    RWA: 'https://sa-stg.pearson.com',
    STP: 'https://sa-stg.pearson.com',
    SEN: 'https://sa-stg.pearson.com',
    SYC: 'https://sa-stg.pearson.com',
    SLE: 'https://sa-stg.pearson.com',
    SOM: 'https://sa-stg.pearson.com',
    TZA: 'https://sa-stg.pearson.com',
    TGO: 'https://sa-stg.pearson.com',
    UGA: 'https://sa-stg.pearson.com',
    ZWE: 'https://sa-stg.pearson.com',
    KOR: 'https://t2-apac-stg.pearson.com',
    MMR: 'https://t3-apac-stg.pearson.com',
    NPL: 'https://t3-apac-stg.pearson.com',
    KHM: 'https://t3-apac-stg.pearson.com',
    TJK: 'https://t3-apac-stg.pearson.com',
    LAO: 'https://t3-apac-stg.pearson.com',
    TKM: 'https://t3-apac-stg.pearson.com',
    TLS: 'https://t3-apac-stg.pearson.com',
    BTN: 'https://t3-apac-stg.pearson.com',
    MDV: 'https://t3-apac-stg.pearson.com',
    BRN: 'https://t3-apac-stg.pearson.com',
    BGD: 'https://t3-apac-stg.pearson.com',
    AIA: 'https://latam-stg.pearson.com',
    ATG: 'https://latam-stg.pearson.com',
    ABW: 'https://latam-stg.pearson.com',
    BRB: 'https://latam-stg.pearson.com',
    VGB: 'https://latam-stg.pearson.com',
    BES: 'https://latam-stg.pearson.com',
    CUW: 'https://latam-stg.pearson.com',
    DMA: 'https://latam-stg.pearson.com',
    FLK: 'https://latam-stg.pearson.com',
    GUF: 'https://latam-stg.pearson.com',
    GRD: 'https://latam-stg.pearson.com',
    GLP: 'https://latam-stg.pearson.com',
    GUY: 'https://latam-stg.pearson.com',
    HTI: 'https://latam-stg.pearson.com',
    MSR: 'https://latam-stg.pearson.com',
    KNA: 'https://latam-stg.pearson.com',
    LCA: 'https://latam-stg.pearson.com',
    SXM: 'https://latam-stg.pearson.com',
    VCT: 'https://latam-stg.pearson.com',
    SUR: 'https://latam-stg.pearson.com',
    TCA: 'https://latam-stg.pearson.com',
    VIR: 'https://latam-stg.pearson.com'
  }
};

export default StoreUrlBase;
